import { render, staticRenderFns } from "./CollapsibleItem.vue?vue&type=template&id=cf59d9e8&scoped=true&"
import script from "./CollapsibleItem.vue?vue&type=script&lang=js&"
export * from "./CollapsibleItem.vue?vue&type=script&lang=js&"
import style0 from "./CollapsibleItem.vue?vue&type=style&index=0&id=cf59d9e8&prod&scoped=true&lang=scss&"
import style1 from "./CollapsibleItem.vue?vue&type=style&index=1&id=cf59d9e8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf59d9e8",
  null
  
)

export default component.exports